import { reactive } from 'vue';

// Aceleres: tipo de conclusão escolhido pelo vendedor ao concluir um
// atendimento. O valor viaja em `conclusion_result` (toggle_status e
// bulk_actions) e fica em `additional_attributes.conclusion_result`, que o
// webhook de conclusão leva ao Laravel. Não muda a etapa do lead.
export const CONCLUSION_RESULTS = Object.freeze({
  SALE_WON: 'sale_won',
  SALE_LOST: 'sale_lost',
  OTHER: 'other',
});

export const CONCLUSION_RESULT_OPTIONS = [
  { value: CONCLUSION_RESULTS.SALE_WON, label: 'Venda realizada' },
  { value: CONCLUSION_RESULTS.SALE_LOST, label: 'Venda perdida' },
  { value: CONCLUSION_RESULTS.OTHER, label: 'Outro motivo' },
];

// Estado único: um modal montado no App.vue atende todos os pontos que
// concluem (menu da conversa, menu do cartão, fechar pelo chat, massa).
export const conclusionPromptState = reactive({
  open: false,
  count: 1,
});

let pendingResolve = null;

const settle = value => {
  const resolve = pendingResolve;
  pendingResolve = null;
  conclusionPromptState.open = false;
  if (resolve) resolve(value);
};

// Devolve o valor escolhido, ou `null` se o vendedor cancelar.
export const requestConclusionResult = ({ count = 1 } = {}) => {
  if (pendingResolve) settle(null);
  conclusionPromptState.count = count;
  conclusionPromptState.open = true;
  return new Promise(resolve => {
    pendingResolve = resolve;
  });
};

export const chooseConclusionResult = value => settle(value);
export const cancelConclusionResult = () => settle(null);
